
'use client';

import React from 'react';
import Link from 'next/link';
import { Button } from '@/components/ui/button';
import { ArrowLeft, ShieldCheck, Mail, Lock, Eye, CheckCircle } from 'lucide-react';

export default function PrivacyPage() {
  return (
    <div className="flex min-h-screen flex-col bg-white">
      {/* Header / Voltar */}
      <div className="border-b px-4 py-3 bg-muted/20">
        <Button asChild variant="ghost" size="sm" className="h-8 text-xs font-bold uppercase">
          <Link href="/">
            <ArrowLeft className="mr-2 h-4 w-4" /> 
            Voltar ao Catálogo
          </Link>
        </Button>
      </div>

      <main className="container mx-auto max-w-4xl px-4 py-12">
        <div className="space-y-12">
          {/* Cabeçalho Técnico */}
          <div className="border-b-4 border-primary pb-4 font-bold">
            <h1 className="text-3xl uppercase tracking-tighter flex items-center gap-3">
              <ShieldCheck className="h-8 w-8 text-primary" />
              Privacidade (LGPD)
            </h1>
            <p className="text-muted-foreground uppercase text-[10px] mt-1 tracking-widest italic">Atualizado em 20 de Abril de 2026</p>
          </div>

          {/* Pilares Diretos */}
          <div className="grid gap-3 md:grid-cols-3">
            {[
              { icon: <Lock size={16} />, text: "Dados Protegidos" },
              { icon: <Eye size={16} />, text: "Uso Transparente" },
              { icon: <CheckCircle size={16} />, text: "Direito de Exclusão" }
            ].map((pilar, i) => (
              <div key={i} className="flex items-center gap-3 p-3 border bg-muted/5 font-bold uppercase text-[10px] tracking-tight">
                 <span className="text-primary">{pilar.icon}</span>
                 {pilar.text}
              </div>
            ))}
          </div>

          {/* Conteúdo do Documento */}
          <div className="text-foreground space-y-8">
            <section>
              <h2 className="text-xs font-bold uppercase border-l-4 border-primary pl-3 mb-2">1. Coleta de Dados</h2>
              <p className="text-[11px] text-muted-foreground leading-relaxed">
                Coletamos apenas o essencial para o funcionamento técnico do catálogo: login de acesso e logs de atividade para segurança. Não vendemos dados para terceiros.
              </p>
            </section>

            <section>
               <h2 className="text-xs font-bold uppercase border-l-4 border-primary pl-3 mb-2">2. Uso de Cookies</h2>
               <p className="text-[11px] text-muted-foreground leading-relaxed">
                 Utilizamos cookies técnicos apenas para manter sua sessão ativa e salvar suas preferências de filtro.
               </p>
            </section>

            <section>
               <h2 className="text-xs font-bold uppercase border-l-4 border-primary pl-3 mb-2">3. Seus Direitos (LGPD)</h2>
               <p className="text-[11px] text-muted-foreground leading-relaxed">
                 O usuário pode solicitar a exclusão de sua conta e dados a qualquer momento via suporte.
               </p>
            </section>
          </div>

          {/* Contato Direto */}
          <div className="bg-primary/5 border p-6 rounded-sm flex flex-col md:flex-row items-center justify-between gap-4">
             <div>
                <h4 className="font-bold text-xs uppercase">Dúvidas sobre Privacidade?</h4>
                <p className="text-[10px] text-muted-foreground italic">Fale com nosso encarregado de dados.</p>
             </div>
             <Button asChild variant="default" className="font-bold rounded-sm h-10 px-6 text-[11px] uppercase">
                <a href="mailto:privacidade@pecanamedida.com.br">
                  <Mail className="mr-2 h-4 w-4" /> Enviar E-mail
                </a>
             </Button>
          </div>
        </div>
      </main>

      <footer className="mt-auto border-t p-6 text-center text-[9px] text-muted-foreground font-bold uppercase tracking-widest">
         Peça na Medida | Segurança de Dados
      </footer>
    </div>
  );
}
